import './amazonGiftCardReturnSuccessStep.scss';
// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const {
    AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS
} = require('constants/tagging');

//@utils
const { recordLinkV2, recordPath } = require("utilities/tagging");

class AmazonGiftCardReturnSuccessStep extends React.Component {
    constructor(props) {
        super(props);

        this.handleNavigateToCodigosClick = this.handleNavigateToCodigosClick.bind(this);
    }

    componentDidMount() {
        recordPath("cuenta/cheque-regalo-codigos/devolucion paso 2/exito", '', AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS, "paso 2/exito");
    }

    handleNavigateToCodigosClick() {
        const customData = ({
            categoriaEvento: "cuenta/cheque-regalo-codigos/devolucion paso 2/exito",
            accionEvento: "volver a la consulta de codigos"
        });
        recordLinkV2(customData);
        this.props.navigateToCodigos();
    }

    render() {
        const titleSuccess = <FormattedText value="amazonGiftCardReturn-successTitle" />;
        const mainButtonLabel = <FormattedText value="amazonGiftCardReturn-backToCodesBtnText" />;
        const mainButton = {
            label: mainButtonLabel
        };
        
        return (
            <div className="col-xs-offset-1 col-xs-10">
                <WizardSuccess
                    mainButton={mainButton}
                    onMainButtonClick={this.handleNavigateToCodigosClick}
                    successMessage={titleSuccess}
                >
                    <div className="amazon-gift-card-return-success-step__content">
                        <FormattedText value="amazonGiftCardReturn-successMessage" />
                        <p className="amazon-gift-card-return-success-step__help-text">
                            <FormattedText value="amazonGiftCard-helpBoxDescription" />
                        </p>
                    </div>
                </WizardSuccess>
            </div>
        );
    }
}

AmazonGiftCardReturnSuccessStep.propTypes = {
    navigateToCodigos: PropTypes.func.isRequired
}

module.exports = AmazonGiftCardReturnSuccessStep;
